<div class="folder-tree-select">
  <!-- Search bar -->
  <div class="search-bar">
    <i class="bi bi-search"></i>
    <input
      type="text"
      placeholder="Rechercher un dossier..."
      [(ngModel)]="searchTerm"
      (keyup)="onSearchChange()"
      />
  </div>

  <div class="folder-tree-container">
    <!-- Root folder option -->
    <div
      class="folder-item root-folder"
      [class.selected]="selectedFolderId === null"
      [class.disabled]="isDisabled(null)"
      (click)="selectFolder(null)"
      >
      <i class="bi bi-house-door"></i> Accueil
      @if (selectedFolderId === null) {
        <span class="checkmark-icon">
          <i class="bi bi-check-lg"></i>
        </span>
      }
    </div>

    <!-- Recursive template for folders -->
    <ng-container
      *ngTemplateOutlet="folderTemplate; context: { folders: filteredFolders, level: 0 }"
    ></ng-container>

    <ng-template #folderTemplate let-folders="folders" let-level="level">
      @for (folder of folders; track folder) {
        <div class="folder-item">
          <div
            class="folder-row"
            [style.padding-left.px]="level * 20 + 12"
            [class.selected]="selectedFolderId === folder.id"
            [class.disabled]="isDisabled(folder)"
            (click)="selectFolder(folder.id)"
            >
            @if (folder.has_children) {
              <span
                class="expand-icon"
                (click)="toggleExpand(folder, $event)"
                >
                <i
              [class]="isExpanded(folder)
                ? 'bi bi-chevron-down'
                : 'bi bi-chevron-right'"
                ></i>
              </span>
            }
            @if (!folder.has_children) {
              <span class="expand-icon"></span>
            }
            <span class="folder-icon">
              <i class="bi bi-folder"></i>
            </span>
            <span class="folder-name">{{ folder.name }}</span>
            @if (selectedFolderId === folder.id) {
              <span class="checkmark-icon">
                <i class="bi bi-check-lg"></i>
              </span>
            }
          </div>
          <!-- Recursively render children if expanded -->
          @if (
            isExpanded(folder) &&
            folder.children &&
            folder.children.length > 0
            ) {
            <div
              >
              <ng-container
            *ngTemplateOutlet="
              folderTemplate;
              context: {
                folders: folder.children,
                level: level + 1
              }
            "
            ></ng-container>
          </div>
        }
      </div>
    }
  </ng-template>
</div>
</div>